"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkFocus = void 0;
function checkFocus(props, ref) {
    var _a;
    return (props.isFocused ||
        (props.isFocused !== false &&
            typeof document !== "undefined" &&
            document.activeElement === ((_a = ref) === null || _a === void 0 ? void 0 : _a.current)));
}
exports.checkFocus = checkFocus;
